import { axios } from '@/utils/request'

/**
 * 客户分类
 * @param parameter
 * @returns {*}
 */
export function getCategoryCustomer (parameter) {
  return axios({
    url: '/cat/customerlist',
    method: 'get',
    params: parameter
  })
}

/**
 * 修改客户分类
 * @param parameter
 * @returns {*}
 */
export function editCategoryCustomer (parameter) {
  return axios({
    url: '/cat/customeredit/' + parameter.id,
    method: 'post',
    data: parameter
  })
}

/**
 * 新增客户分类
 * @param parameter
 * @returns {*}
 */
export function addCategoryCustomer (parameter) {
  return axios({
    url: '/cat/customeradd',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除客户份额里
 * @param parameter
 * @returns {*}
 */
export function deleteCategoryCustomer (parameter) {
  return axios({
    url: '/cat/customerdelete',
    method: 'post',
    data: parameter
  })
}

/**
 * 供应商分类
 * @param parameter
 * @returns {*}
 */
export function getCategorySupplier (parameter) {
  return axios({
    url: '/cat/supplierlist',
    method: 'get',
    params: parameter
  })
}

/**
 * 修改供应商分类
 * @param parameter
 * @returns {*}
 */
export function editCategorySupplier (parameter) {
  return axios({
    url: '/cat/supplieredit/' + parameter.id,
    method: 'post',
    data: parameter
  })
}

/**
 * 添加供应商分类
 * @param parameter
 * @returns {*}
 */
export function addCategorySupplier (parameter) {
  return axios({
    url: '/cat/supplieradd',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除供应商分类
 * @param parameter
 * @returns {*}
 */
export function deleteCategorySupplier (parameter) {
  return axios({
    url: '/cat/supplierdelete',
    method: 'post',
    data: parameter
  })
}

/**
 * 商品分类
 * @param parameter
 * @returns {*}
 */
export function getCategoryGoods (parameter) {
  return axios({
    url: '/cat/goodslist',
    method: 'get',
    params: parameter
  })
}

/**
 * 修改商品分类
 * @param parameter
 * @returns {*}
 */
export function editCategoryGoods (parameter) {
  return axios({
    url: '/cat/goodsedit/' + parameter.id,
    method: 'post',
    data: parameter
  })
}

/**
 * 添加商品分类
 * @param parameter
 * @returns {*}
 */
export function addCategoryGoods (parameter) {
  return axios({
    url: '/cat/goodsadd',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除商品分类
 * @param parameter
 * @returns {*}
 */
export function deleteCategoryGoods (parameter) {
  return axios({
    url: '/cat/goodsdelete',
    method: 'post',
    data: parameter
  })
}
